
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 233 233","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.82 155.182c-29.093-29.108-29.093-76.273 0-105.364 29.093-29.09 76.262-29.09 105.373 0 29.076 29.091 29.076 76.256 0 105.364-29.11 29.09-76.28 29.09-105.373 0m181.56 56.644l-48.24-48.236c30.413-40.04 27.75-97.145-8.783-133.676-39.888-39.885-104.553-39.885-144.441 0-39.888 39.885-39.888 104.545 0 144.43 36.534 36.53 93.643 39.193 133.686 8.8l48.24 48.235a5.52 5.52 0 007.814 0l11.723-11.739a5.52 5.52 0 000-7.814"}})])
          )
        }
      }
    